// New component for the experience level switch
import React from 'react';
import { cx } from "lib/cx";

interface ExperienceSwitchProps {
  selectedExperience: "FRESHER" | "EXPERIENCED" | null;
  onChange: (value: "FRESHER" | "EXPERIENCED") => void;
  className?: string;
}

export const ExperienceSwitch: React.FC<ExperienceSwitchProps> = ({ 
  selectedExperience, 
  onChange,
  className
}) => {
  return (
    <div className={cx(
      "flex bg-gray-100 p-1 rounded-full w-fit shadow-inner", 
      className
    )}>
      <button
        onClick={() => onChange("FRESHER")}
        className={cx(
          "px-4 py-1 rounded-full text-sm font-medium transition-all duration-200",
          selectedExperience === "FRESHER" 
            ? "bg-white text-blue-600 shadow-md" 
            : "text-gray-600 hover:text-gray-800"
        )}
      >
        Fresher
      </button>
      <button
        onClick={() => onChange("EXPERIENCED")}
        className={cx(
          "px-4 py-1 rounded-full text-sm font-medium transition-all duration-200",
          selectedExperience === "EXPERIENCED" 
            ? "bg-white text-blue-600 shadow-md" 
            : "text-gray-600 hover:text-gray-800"
        )}
      >
        Experienced
      </button>
    </div>
  );
};